import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { PveRunPage } from './run/PveRunPage';
import { PveRunsPage } from './run/PveRunsPage';
import { PveLeaderboard } from './leaderboard/PveLeaderboard';

export const PveContainer: React.FC = () => (
  <Switch>
    <Route exact path="/pve/runs" component={PveRunsPage} />
    <Route path="/pve/run/:id" component={PveRunPage} />
    <Route exact path="/pve/leaderboard" component={PveLeaderboard} />
    <Redirect to="/pve/runs" />
  </Switch>
);
